import React from 'react';
import TextInput from './TextInput/TextInput';
import './PasswordInput.css';
import { i18n } from 'utils/translate';

function PasswordInput({ name, disabled, onChange }) {
    return (
        <TextInput
            name={name}
            label={i18n('g_password')}
            type="password"
            required
            color="thribee-yellow"
            disabled={disabled}
            className="PasswordInput"
            onChange={onChange}
        />
    );
}

export default PasswordInput;
